module.exports = __webpack_public_path__ + "img/grolsheim.ac6e4d5e.jpg";